import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import firebase from 'firebase/app'
import router from './router'
import { get } from 'lodash'
import { Settings } from 'luxon'

import { getUser } from '@/lib/api.js'

Vue.use(Vuex)

function getCurrentFirebaseUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe()
      resolve(user)
    })
  })
}

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['miniVariant', 'language', 'hideAmounts', 'theme', 'supplantedUser'],
    }),
  ],
  state: {
    logged: null,
    user: null,
    firebaseUser: null,
    loginError: null,
    language: null,
    hideAmounts: null,
    theme: null,
    supplantedUser: null,
    userStatusLimitsError: null,

    drawer: null,
    miniVariant: null,
  },
  mutations: {
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_MINIVARIANT(state, payload) {
      state.miniVariant = payload
    },
    SET_AUTH_INFO(state, { user, firebaseUser }) {
      state.user = user
      state.firebaseUser = firebaseUser
    },
    LOGGED_IN(state) {
      state.logged = true
    },
    LOGGED_OUT(state) {
      state.logged = false
      state.drawer = null
    },
    SET_LOGIN_ERROR(state, { loginError }) {
      state.loginError = loginError
    },
    SET_SIGN_MESSAGE(state, { signMessage }) {
      state.signMessage = signMessage
    },
    SET_LANGUAGE(state, language) {
      state.language = language
    },
    SET_HIDE_AMOUNTS(state, value) {
      state.hideAmounts = value
    },
    SET_THEME(state, theme) {
      state.theme = theme
    },
    SET_SUPPLANTED_USER(state, user) {
      state.supplantedUser = user
    },
    SET_USER_STATUS_LIMITS_ERROR(state, error) {
      state.userStatusLimitsError = error
    },
  },
  getters: {
    isLogged(state) {
      return state.logged
    },
    getUser(state) {
      return state.user
    },
    isAdminOrTesterRoleUser(state) {
      const role = get(state.user, 'role', null)
      return role === 'admin' || role === 'tester'
    },
    isPartnerRoleUser(state) {
      const role = get(state.user, 'role', null)
      return role === 'partner'
    },
  },
  actions: {
    async LOGIN({ commit, dispatch }) {
      await dispatch('INIT')
    },
    async INIT({ state, commit, dispatch }) {
      try {
        if (!!router.history.pending && !router.history.pending.meta.requiredAuth)
          return commit('LOGGED_OUT')

        const firebaseUser = await getCurrentFirebaseUser()
        if (!firebaseUser) return dispatch('LOGOUT')

        const userResponse = await getUser({ uid: firebaseUser.uid })
        const user = userResponse.data
        if (!user) return dispatch('LOGOUT')

        Settings.defaultZoneName = user.preferences.timezone

        commit('LOGGED_IN')
        commit('SET_AUTH_INFO', {
          user,
          firebaseUser,
        })
      } catch (err) {
        dispatch('LOGOUT')
      }
    },
    async SET_SIGN_MESSAGE({ state, commit }, message) {
      commit('SET_SIGN_MESSAGE', message)
    },
    async LOGOUT({ commit }, data) {
      if (data && data.loginError) {
        commit('SET_LOGIN_ERROR', { loginError: data.loginError })
      } else {
        commit('SET_LOGIN_ERROR', { loginError: null })
      }

      commit('SET_SUPPLANTED_USER', undefined)

      commit('LOGGED_OUT')
      await firebase.auth().signOut()

      // if (get(router, 'history.current.name', undefined) !== 'login')
      //   router.replace({
      //     name: 'login',
      //   })
    },
    async UPDATE_USERS_INFO({ commit, dispatch }) {
      await dispatch('INIT')
    },
    async SET_USER_STATUS_LIMITS_ERROR({ state, commit }, name) {
      commit('SET_USER_STATUS_LIMITS_ERROR', name)
    },
  },
})
